export default {
  root: {
    display: 'flex',
    flexFlow: 'row nowrap'
  }
};